<template>
    <div>
        <div class="pre_chart_loader">
            <div style="font-size: 46px">
                <img src="@/assets/images/box.png"/>
            </div>
            <p>কোন তথ্য পাওয়া যায়নি</p>
        </div>
    </div>
</template>

<script>
    export default {
        name: "EmptyChart"
    }
</script>

<style scoped>
    .pre_chart_loader{
        text-align: center;
        text-transform: capitalize;
    }
</style>